import { useEffect } from 'react';

/**
 * Lightweight replacement for react-helmet. Updates <title> and the
 * <meta name="description"> + og:title/og:description tags when the
 * current route mounts. Restores site-wide defaults on unmount.
 */
const DEFAULT_TITLE = 'Smart Growth Tech | AI Office Manager for HVAC, Plumbing & Electrical Contractors';
const DEFAULT_DESCRIPTION =
  "Smart Growth Tech builds AI Office Managers for HVAC, plumbing, and electrical contractors. Answer every call, qualify every lead, and book jobs 24/7 — so you never lose another $5,000 ticket to voicemail.";

const setMeta = (selector, attr, value) => {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute(attr, value);
};

export const usePageMeta = ({ title, description }) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      setMeta('meta[name="description"]', 'content', description);
      setMeta('meta[property="og:description"]', 'content', description);
    }
    if (title) {
      setMeta('meta[property="og:title"]', 'content', title);
      setMeta('meta[name="twitter:title"]', 'content', title);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', 'content', DEFAULT_DESCRIPTION);
      setMeta('meta[property="og:description"]', 'content', DEFAULT_DESCRIPTION);
      setMeta('meta[property="og:title"]', 'content', DEFAULT_TITLE);
      setMeta('meta[name="twitter:title"]', 'content', DEFAULT_TITLE);
    };
  }, [title, description]);
};

export default usePageMeta;
